import script from "./ParentPasswordModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentPasswordModal.vue?vue&type=script&setup=true&lang=js"

import "./ParentPasswordModal.vue?vue&type=style&index=0&id=0957f5ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0957f5ed"]])

export default __exports__